/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetTenantsOptions, GetTenantsResponses } from '../types/GetTenants'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get tenants
 * {@link /v1/tenants}
 */
export function getTenants<ThrowOnError extends boolean = true>(
  options: Options<GetTenantsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetTenantsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/tenants',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTenantsResponses, ThrowOnError>>,
  )
}
